var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNatureHouse(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 1210 1210",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_227_6951)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 16,
    width: 1178,
    height: 1178,
    rx: 80,
    fill: "white",
    stroke: "black",
    strokeWidth: 32
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1004.06 500.739L1105.16 503.742L602.658 118.357L118.174 497.314L211.267 500.317L217.273 1021.26H104.16V1118.36H1105.16V1021.26H1004.06L1004.06 500.739ZM701.061 683.704C670.341 763.201 601.261 826.237 530.794 856.633C524.718 859.255 521.074 864.113 518.644 868.972C494.448 923.278 510.019 1020.48 510.408 1030.53C511.375 1055.54 494.766 1050.34 487.467 1035.55C470.154 1000.48 467.61 918.837 472.478 870.19C473.693 858.039 467.619 851.964 462.758 844.676C429.339 797.331 341.445 657.935 460.48 500.591C532.474 407.728 631.83 387.074 670.418 316.442C740.424 407.101 739.131 584.388 701.061 683.704Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M478.648 784.147C486.676 821.481 532.665 817.923 528.134 741.352C525.007 688.497 550.033 556.063 644.994 435.248C468.696 560.234 474.417 735.417 478.648 784.147Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_227_6951"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1210,
    height: 1210,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNatureHouse);
export default __webpack_public_path__ + "static/media/NatureHouse.369bca404d7ea6aa91a7920bfbd106d1.svg";
export { ForwardRef as ReactComponent };